const doc = [({"en":({"js":({"admin":({"school_classes":({"table":({"people_count":"People count"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;